// src/redux/slices/employeeReportSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_API_URL;

// // Async thunk with pagination support
// export const fetchEmployeeReport = createAsyncThunk(
//   'employeeReport/fetchEmployeeReport',
//   async (page = 1, thunkAPI) => {
//     try {
//       const token = localStorage.getItem('authToken');

//       if (!token || token === 'undefined') {
//         throw new Error('No auth token found');
//       }

//       const response = await axios.get(
//         `${BASE_URL}/get-employ?superAdminId=${localStorage.getItem('adminuserId')}?page=${page}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       return {
//         data: response.data.data,
//         currentPage: response.data.currentPage,
//         totalPages: response.data.totalPages,
//         totalEmployees: response.data.totalEmployees,
//       };
//     } catch (error) {
//       return thunkAPI.rejectWithValue(
//         error.response?.data?.message || error.message || 'Fetch failed'
//       );
//     }
//   }
// );



// Async thunk with pagination and userId support
// export const fetchEmployeeReport = createAsyncThunk(
//   'employeeReport/fetchEmployeeReport',
//   async ({ page = 1, userId = '' }, thunkAPI) => {
//     try {
//       const token = localStorage.getItem('authToken');
//       const superAdminId = localStorage.getItem('adminuserId');

//       if (!token || token === 'undefined') {
//         throw new Error('No auth token found');
//       }

//       // Build query params dynamically
//       const params = new URLSearchParams();
//       params.append('superAdminId', superAdminId);
//       params.append('page', page);
//       if (userId) params.append('userId', userId);

//       const response = await axios.get(`${BASE_URL}/get-employ?${params.toString()}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       return {
//         data: response.data.data,
//         currentPage: response.data.currentPage,
//         totalPages: response.data.totalPages,
//         totalEmployees: response.data.totalEmployees,
//       };
//     } catch (error) {
//       return thunkAPI.rejectWithValue(
//         error.response?.data?.message || error.message || 'Fetch failed'
//       );
//     }
//   }
// );

// fetch employee report
export const fetchEmployeeReport = createAsyncThunk(
  'employeeReport/fetchEmployeeReport',
  async ({ page = 1, pageSize = 10, filterType, filterValue, branch, fromDate, toDate }, thunkAPI) => {
    try {
      const token = localStorage.getItem('authToken');
      const superAdminId = localStorage.getItem('adminuserId');

      if (!token || token === 'undefined') throw new Error('No auth token found');

      const params = new URLSearchParams();
      params.append('superAdminId', superAdminId);
      params.append('page', page);
      params.append('limit', pageSize); // Ensure backend uses limit
      if (filterType && filterValue) params.append(filterType, filterValue);
      if (branch) params.append('branch', branch);
      if (fromDate) params.append('fromDate', fromDate);
      if (toDate) params.append('toDate', toDate);

      const response = await axios.get(`${BASE_URL}/get-employ?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log(response.data.data)
      return {
        data: response.data.data,
        currentPage: response.data.currentPage,
        totalPages: response.data.totalPages,
        totalEmployees: response.data.totalEmployees,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message || 'Fetch failed');
    }
  }
);

// update employee by id
export const updateEmployee = createAsyncThunk(
  "employeeReport/updateEmployee",
  async ({ id, payload }, thunkAPI) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) throw new Error("No auth token");

      const res = await axios.put(
        `${BASE_URL}/hr-employees/${id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // toast.success("Employee updated successfully");

      // ✅ Get current employee report state
      const {
        page,
        pageSize,
        filterType,
        filterValue,
        branch,
        fromDate,
        toDate,
      } = thunkAPI.getState().employeeReport;

      // ✅ Refresh employee report with SAME filters & pagination
      thunkAPI.dispatch(
        fetchEmployeeReport({
          page,
          pageSize,
          filterType,
          filterValue,
          branch,
          fromDate,
          toDate,
        })
      );

      return { id, ...payload };
    } catch (error) {
      toast.error(error.response?.data?.message || "Update failed");
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



// const employeeReportSlice = createSlice({
//   name: 'employeeReport',
//   initialState: {
//     list: [],
//     loading: false,
//     error: null,
//     currentPage: 1,
//     totalPages: 1,
//     totalEmployees: 0,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchEmployeeReport.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchEmployeeReport.fulfilled, (state, action) => {
//         state.loading = false;
//         state.list = action.payload.data;
//         state.currentPage = action.payload.currentPage;
//         state.totalPages = action.payload.totalPages;
//         state.totalEmployees = action.payload.totalEmployees;
//       })
//       .addCase(fetchEmployeeReport.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });


// ✅ Delete employee by ID
export const deleteEmployee = createAsyncThunk(
  "employeeReport/deleteEmployee",
  async (employeeId, thunkAPI) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token || token === "undefined") {
        throw new Error("No auth token found");
      }

      await axios.delete(`${BASE_URL}/hr-employee-delete/${employeeId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return employeeId; // return deleted employeeId to update state
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message || "Delete failed"
      );
    }
  }
);

const employeeReportSlice = createSlice({
  name: "employeeReport",
  initialState: {
    list: [],
    loading: false,
    error: null,
    currentPage: 1,
    totalPages: 1,
    totalEmployees: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ✅ Fetch employees
      .addCase(fetchEmployeeReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeReport.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.currentPage = action.payload.currentPage;
        state.totalPages = action.payload.totalPages;
        state.totalEmployees = action.payload.totalEmployees;
      })
      .addCase(fetchEmployeeReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

       // 🔹 Update employee
      .addCase(updateEmployee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateEmployee.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateEmployee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ✅ Delete employee
      .addCase(deleteEmployee.fulfilled, (state, action) => {
        state.list = state.list.filter((emp) => emp.id !== action.payload);
        state.totalEmployees = Math.max(0, state.totalEmployees - 1);
      })
      .addCase(deleteEmployee.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});


export default employeeReportSlice.reducer;
